import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { RecipeSection } from '@ledium/types';
import { Grid } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import ColorPicker from 'rc-color-picker';
import 'rc-color-picker/assets/index.css';

interface SectionColorPickerProps {
    sectionData: RecipeSection;
    setSectionData: (data: RecipeSection) => void;
}

function invertColor(hex: string) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
}

const SectionColorPicker = ({ setSectionData, sectionData }: SectionColorPickerProps) => {
    const {
        pageState: { formData }
    } = usePageStore();

    const [color, setColor] = React.useState('#FFFFFF');

    React.useEffect(() => {
        setColor(sectionData.sectionColor?.background || '#FFFFFF');
    }, [sectionData.sectionColor]);

    function onColorChange(newColor: { color: string }) {
        setSectionData({
            ...sectionData,
            sectionColor: {
                background: newColor.color,
                text: invertColor(newColor.color)
            }
        });
        setColor(newColor.color);
    }

    return (
        <Grid item xs={4}>
            {formData.readOnly ? null : (
                <>
                    <InputLabel shrink>{i18n('select_section_background_color')}</InputLabel>
                    <ColorPicker color={color} onChange={onColorChange} enableAlpha={false} placement="topRight" style={{ zIndex: 1500 }}>
                        <div className="current-color react-custom-trigger" />
                    </ColorPicker>
                </>
            )}
        </Grid>
    );
};

export default SectionColorPicker;
